module.exports = __webpack_public_path__ + "img/home-img-local-travel.8072e29d.jpg";